import { render, staticRenderFns } from "./BaseSignBlock.vue?vue&type=template&id=5b160b4c&scoped=true&"
import script from "./BaseSignBlock.vue?vue&type=script&lang=js&"
export * from "./BaseSignBlock.vue?vue&type=script&lang=js&"
import style0 from "./BaseSignBlock.vue?vue&type=style&index=0&id=5b160b4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b160b4c",
  null
  
)

export default component.exports